import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import { BuildContext } from "../classes/BuildContext";

export interface ContactSupportProps extends BaseUIProps {
  key?: string;
}

class _ContactSupportState extends ObservableComponent<ContactSupportProps> {
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: ContactSupportProps) {
    super(props);

    this.initState();
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {}
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisAlignment: ui.MainAxisAlignment.center,
      crossAxisAlignment: ui.CrossAxisAlignment.center,
      children: [
        ui.Container({
          child: ui.Column({
            mainAxisAlignment: ui.MainAxisAlignment.center,
            crossAxisAlignment: ui.CrossAxisAlignment.center,
            children: [
              TextView({
                data: "Thank you for submitting your project request! Our team will review the details and be in touch with you shortly.",
                style: new ui.TextStyle({
                  fontSize: 18,
                  fontWeight: ui.FontWeight.bold,
                  color: cStyle.c6,
                }),
                className: "x802 hc",
                key: "0",
              }),
            ],
            className: "xcd hc vc v",
          }),
          className: "x31 hc vc",
          key: "0",
        }),
      ],
      className: ui.join(this.props.className, "ContactSupport x23a hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function ContactSupport(props: ContactSupportProps) {
  return React.createElement(_ContactSupportState, props);
}
